import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/default/header";
import Footer from "../../components/default/footer";
import SubscriptionReport from "./subscriptionReport";
import SubscriptionList from "./subscriptionList";
import GlobalSidebarMenu from "../default/header/globalSidebarMenu";
import Breadcrumb from "../default/breadcrumb/breadcrumb";


const ActiveSubscription = () => {
    return (
        <div className="content-wrapper sidebar-menu-enable">
            <Helmet><title>Subscription - Cardiast</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
                <GlobalSidebarMenu sidebarTitle="Subscription"/>
                <div className="content-right">
                    <Breadcrumb />
                    <SubscriptionReport />
                    <SubscriptionList />
                </div>
            </div>
        </div>
    );
}

export default ActiveSubscription;
